import { useEffect, useState } from 'react'
import { get } from '../../../Services/api'
import yyyy_mm_dd_date_format from '../../../Utility/yyyy_mm_dd_date_format';
import { useNavigate } from 'react-router-dom';

import './UpcomingMeal.css'

function UpcomingMeal({ currentUser }) {
    const days_week = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
    const [meals, setMeals] = useState([])
    const today = yyyy_mm_dd_date_format({})
    const [date, setDate] = useState(today)
    const [weekDates, setWeekDates] = useState(getWeekDates(today))
    const [nextButtonBold, setNextButtonBold] = useState(true)
    const navigate = useNavigate();

    function goToPage(path) {
        navigate(path);
    }

    function getWeekDates(dateString) {
        const result = []
        const date_utc = new Date(dateString + "T00:00:00Z");
        days_week.map((day, i) => {
            const day_diff = i - date_utc.getUTCDay() // Get the day of the week as a number (Sunday=0, Monday=1, ..., Saturday=6)
            if (day_diff < 0) {
                const tmp = yyyy_mm_dd_date_format({ i_date: date, sub_days: (day_diff * -1) })
                result.push({
                    date: tmp,
                    day: tmp.split("-")[2],
                    selected: tmp === date
                })
            } else {
                const tmp = yyyy_mm_dd_date_format({ i_date: date, add_days: day_diff })
                result.push({
                    date: tmp,
                    day: tmp.split("-")[2],
                    selected: tmp === date
                })
            }
        })

        return result;
    }

    useEffect(() => {
        get_user_daily_meal_plan()

        setWeekDates(getWeekDates(date))
    }, [date])

    useEffect(() => {
        if (weekDates[0].date > date)
            setNextButtonBold(false)
        else
            setNextButtonBold(true)
    }, [weekDates])

    async function get_user_daily_meal_plan() {
        try {
            const resp = await get("/api/user/get-user-daily-meal-plan", {
                user_id: currentUser.uid,
                date: date
            })
            setMeals(resp)
        } catch (e) {
            // Could not fetch user meal plan or no meal plan is schedualed
            setMeals([])
        }
    }

    // Return month of date
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function getDateMonth(dateString) {
        return months[parseInt(dateString.split("-")[1]) - 1]
    }

    function nextWeek() {
        const result = []
        const last_day_of_week = weekDates[weekDates.length - 1].date
        days_week.map((day, i) => {
            const tmp = yyyy_mm_dd_date_format({ i_date: last_day_of_week, add_days: i + 1 })
            result.push({
                date: tmp,
                day: tmp.split("-")[2],
                selected: tmp === date
            })
        })
        setWeekDates(result)
    }
    function previousWeek() {
        const result = []
        const first_day_of_week = weekDates[0].date
        days_week.map((day, i) => {
            const tmp = yyyy_mm_dd_date_format({ i_date: first_day_of_week, sub_days: 7 - i })
            result.push({
                date: tmp,
                day: tmp.split("-")[2],
                selected: tmp === date
            })
        })
        setWeekDates(result)
    }

    return (
        <div className="component_padding black">
            <div className='flex align_center justify_space_between'>
                <h4 className='font_family_ovo no_margin'>{weekDates[0].day + ' - ' + weekDates[weekDates.length - 1].day + ' ' + getDateMonth(weekDates[weekDates.length - 1].date)}</h4>

                <div className='flex gap_12 align_center'>
                    <div className={(!nextButtonBold ? 'dashboard-upcoming-meal-calendar-button-half-circle' : 'dashboard-upcoming-meal-calendar-button-full-circle') + ' flex align_center justify_center cursor_pointer'} onClick={previousWeek}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M11 15L5 9L11 3" stroke="url(#paint0_linear_1_2093)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <defs>
                                <linearGradient id="paint0_linear_1_2093" x1="14" y1="11.625" x2="10.7448" y2="1.13302" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#235539" />
                                    <stop offset="1" stopColor="#7B946B" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div className={(nextButtonBold ? 'dashboard-upcoming-meal-calendar-button-half-circle' : 'dashboard-upcoming-meal-calendar-button-full-circle') + ' flex align_center justify_center cursor_pointer'} onClick={nextWeek}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M7 15L13 9L7 3" stroke="url(#paint0_linear_1_2096)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <defs>
                                <linearGradient id="paint0_linear_1_2096" x1="4" y1="11.625" x2="7.25521" y2="1.13302" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#235539" />
                                    <stop offset="1" stopColor="#7B946B" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>

            <div className='component_heading_separating_line'></div>

            <div className='flex align_center justify_space_between'>
                {days_week.map((day, i) => (
                    <div key={i} className='flex flex_column align_center justify_center gap_12 text_align_center cursor_pointer' onClick={() => setDate(weekDates[i].date)}>
                        <p className={(weekDates[i].selected ? 'gray_scale_1' : 'gray_scale_3') + ' font_weight_600 no_margin'}>{day}</p>
                        <p className={(weekDates[i].selected ? 'dashboard-upcoming-meal-calendar-date-selected' : 'gray_scale_1') + ' dashboard-upcoming-meal-calendar-date no_margin'}>
                            {weekDates[i].day}
                        </p>
                    </div>
                ))}
            </div>

            <div className='dashboard-upcoming-meal-list'>
                {meals.map((meal, i) => (
                    <div key={i} className='dashboard-upcoming-meal-indiv-meal flex flex_column gap_12 align_center justify_center text_align_center cursor_pointer'
                        onClick={() => goToPage('/meal-details/' + meal.meal_id)}>
                        <img src={meal.image} className='dashboard-upcoming-meal-indiv-meal-img' />
                        <p className='no_margin font_size_12'>{meal.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}


export default UpcomingMeal;